import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForgotPasswordMutation } from '../features/auth/authApi';
import InlineError from '../components/InlineError';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [forgotPassword, { isLoading, error, isSuccess }] = useForgotPasswordMutation();
    const navigate = useNavigate();

    async function onSubmit(e: React.FormEvent) {
        e.preventDefault();
        try {
            await forgotPassword({ email }).unwrap();
            // After success, we don't navigate immediately, but show success message or redirect to reset
            setTimeout(() => {
                navigate('/reset-password', { state: { email } });
            }, 2000);
        } catch (err) {
            // Handled by error state
        }
    }

    return (
        <div className="flex min-h-screen items-center justify-center p-6" style={{ background: '#0f172a', fontFamily: "'Inter', sans-serif" }}>
            <div className="w-full max-w-md">
                <div className="mb-8 text-center">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4" style={{ background: 'linear-gradient(135deg, #3b82f6, #6366f1)' }}>
                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a3 3 0 11-6 0 3 3 0 016 0zM12 14c-4.478 0-8.268 2.943-9.543 7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                        </svg>
                    </div>
                    <h1 className="text-3xl font-bold text-white">Reset Password</h1>
                    <p className="mt-2 text-blue-300">Enter your details to receive an OTP</p>
                </div>

                {isSuccess ? (
                    <div className="p-6 rounded-2xl bg-green-500/10 border border-green-500/20 text-center">
                        <p className="text-green-400 font-medium">OTP sent successfully!</p>
                        <p className="text-green-500/60 text-sm mt-1">Redirecting to reset page...</p>
                    </div>
                ) : (
                    <form onSubmit={onSubmit} className="space-y-5">
                        <div className="mb-2">
                            <label htmlFor="email" className="block text-sm font-medium text-blue-200 mb-2">
                                Email address
                            </label>
                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-3 rounded-xl text-white placeholder-blue-400 outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                                style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}
                                placeholder="you@company.com"
                                required
                            />
                        </div>

                        <InlineError message={(error as any)?.data?.error?.message || (error as any)?.data?.message || (error as any)?.error} />

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full py-3 px-4 rounded-xl font-semibold text-white text-base transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed hover:opacity-90 active:scale-[0.98]"
                            style={{ background: 'linear-gradient(135deg, #3b82f6, #6366f1)' }}
                        >
                            {isLoading ? 'Sending OTP...' : 'Send Reset OTP'}
                        </button>
                    </form>
                )}

                <div className="mt-8 text-center pt-6" style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}>
                    <Link to="/login" className="text-sm text-blue-400 hover:text-white transition-colors">
                        Back to Sign In
                    </Link>
                </div>
            </div>
        </div>
    );
}
